import React,{useEffect,useState} from 'react';
import TextAnimate from './TextAnimate';
import '../styles/ProjectsPattern.css'
const ProjectsPattern = ({trigger})=>{
    const [isTriggered,setIsTrigerred] = useState(false)
    const FirstStageClass = isTriggered ? 'first-part-project' : 'initial'
    const SecondStageClass = isTriggered ? 'second-part-project' : 'initial'
    useEffect(()=>{
        if(trigger){
           setIsTrigerred(true)
        }
       })


    return(
        <>

<svg  className={FirstStageClass} width="200" height="440" viewBox="0 0 200 440" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="50.0715" y="0.707107" width="9" height="9" transform="rotate(45.0039 50.0715 0.707107)" stroke="#0066FF"/>
<rect x="148.072" y="0.707107" width="9" height="9" transform="rotate(45.0039 148.072 0.707107)" stroke="#0066FF"/>
<rect x="100.072" y="50.7071" width="9" height="9" transform="rotate(45.0039 100.072 50.7071)" stroke="#0066FF"/>
<path d="M79 38V277V413.5L64.5 433.5H9.5" stroke="#0066FF"/>
<path d="M120 38V276.698V413.025L134.5 433H189" stroke="#0066FF"/>
<path d="M148 13V78.0978L120 119" stroke="#0066FF"/>
<path  d="M50 13V78.0978L79 119" stroke="#0066FF"/>
<path d="M100 63L99.3386 432.772" stroke="#0066FF"/>
<circle cx="194.019" cy="433.019" r="4.5" transform="rotate(0.222555 194.019 433.019)" stroke="#0066FF"/>
<circle cx="5.01938" cy="434.019" r="4.5" transform="rotate(0.222555 5.01938 434.019)" stroke="#0066FF"/>
<path id='fourth-part' d="M144 83V102.5L129.5 123V210L120 223" stroke="#0066FF"/>
<path d="M55 85V102.543L69.5 123.088V167.685V210L79 222.5" stroke="#0066FF"/>
<path d="M136 114V181.427L130 193" stroke="#0066FF"/>
<path d="M63 114V181L69.5 192.5" stroke="#0066FF"/>
</svg>

<TextAnimate direction="toTop">
    <p>OpenSource Projects</p>
    </TextAnimate>
<svg className={SecondStageClass} width="199" height="217" viewBox="0 0 199 217" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M99.7846 1L99 202.998" stroke="#0066FF"/>
<path d="M9 7H64.7407L79 27L78.3518 162.5L54.0463 195" stroke="#0066FF"/>
<circle cx="194" cy="7" r="4.5" stroke="#0066FF"/>
<circle cx="148" cy="199" r="4.5" stroke="#0066FF"/>
<circle cx="5" cy="7" r="4.5" stroke="#0066FF"/>
<rect x="99.0715" y="202.707" width="9" height="9" transform="rotate(45.0039 99.0715 202.707)" stroke="#0066FF"/>
<path d="M190 7H134.259L120 27L120.648 162.5L144.954 195" stroke="#0066FF"/>
<circle cx="52" cy="199" r="4.5" stroke="#0066FF"/>
<path d="M130 12.7681V118.751L120.5 131.5" stroke="#0066FF"/>
<path d="M69 13V118.751L78.5 130.5" stroke="#0066FF"/>

</svg>










</>
    )
}

export default ProjectsPattern;